<template>
  <v-card
    color="blue-grey darken-2"
    class="white--text pt-0 pb-0 mt-0 mb-0"
    v-if="totalBilling && totalBilling.id && totalBilling.power_plant"
  >
    <v-container grid-list-md class="pt-0 pb-0">
      <v-layout
        class="row wrap align-center justify-end row fill-height pt-0 pb-0"
      >
        <v-flex xs12 sm12 md8>
          <v-card-title primary-title>
            <div>
              <div class="headline">{{ totalBilling.power_plant.name }}</div>
              <span v-if="totalBilling.installation_number"
                >UC: {{ totalBilling.installation_number || "" }}</span
              >
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-btn round color="blue">
                {{ totalBilling.competence }}
              </v-btn>
            </div>
            <v-spacer></v-spacer>
            <div v-if="totalBilling.account_url">
              <v-btn
                round
                flat
                outline
                color="blue"
                :href="totalBilling.account_url"
                target="_blank"
              >
                Conta Usina
                <!-- <a :href="totalBilling.account_url" target="_blank">     -->
                <v-icon right color="white">request_quote</v-icon>
                <!-- </a> -->
              </v-btn>
            </div>
            <v-spacer></v-spacer>
            <!-- <div>
                            <v-btn round flat outline color="blue" @click="setBillingDetails(true)">
                                Faturas 
                                <v-icon right dark >read_more</v-icon>
                            </v-btn>
                        </div> -->
          </v-card-title>
        </v-flex>
        <v-flex xs12 sm12 md4>
          <v-card-title primary-title class="text--rigth">
            <v-spacer></v-spacer>
            <div>
              Últ. Atualização:
              {{
                totalBilling && totalBilling.summarize
                  ? totalBilling.summarize.updated_at
                  : "" | formatDate
              }}
            </div>
            <div>
              <v-spacer></v-spacer>
              <v-btn flat color="white" icon>
                <v-icon>update</v-icon>
              </v-btn>
            </div>
          </v-card-title>
        </v-flex>
      </v-layout>
    </v-container>
    <billing-details />
  </v-card>
</template>
<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import BillingDetails from "./BillingDetails.vue";

export default {
  components: {
    BillingDetails,
  },
  data: () => ({
    // totalBilling: {},
    //dialog_details: false,
  }),
  mounted() {
    // if(this.totalBilling) this.totalBilling = this.totalBilling
  },
  computed: {
    ...mapState("billing", ["totalBilling", "billings"]),
  },
  // watch: {
  //     totalBilling() {
  //         this.totalBilling = this.totalBilling
  //     }
  // },
  filters: {
    formatDate(value) {
      if (!value || value === "") return "";
      return moment(value.toDate()).format("DD/MM/YYYY");
    },
  },
  methods: {
    ...mapActions("billing", ["DialogDetails"]),
    setBillingDetails(param) {
      this.DialogDetails(param);
    },
  },
};
</script>
